// src/components/admin/AdminSubscribers.jsx
import { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';

export default function AdminSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);

  async function fetchSubscribers() {
    try {
      let snap;
      try {
        snap = await getDocs(query(collection(db, 'subscribers'), orderBy('subscribedAt', 'desc')));
      } catch {
        snap = await getDocs(collection(db, 'subscribers'));
      }
      setSubscribers(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchSubscribers(); }, []);

  const formatDate = (sub) => {
    const ts = sub.subscribedAt;
    if (!ts) return '—';
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  async function handleDelete(sub) {
    if (!window.confirm(`Remove ${sub.email} from subscribers?`)) return;
    try {
      await deleteDoc(doc(db, 'subscribers', sub.id));
      await fetchSubscribers();
    } catch (err) {
      alert('Delete failed: ' + err.message);
    }
  }

  function exportCSV() {
    const headers = 'Email,Source,Date';
    const rows = subscribers.map(s => `"${s.email}","${s.source || ''}","${formatDate(s)}"`);
    const csv = [headers, ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'subscribers.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px', flexWrap: 'wrap', gap: '16px' }}>
        <div>
          <h2 className="title-4">Subscribers</h2>
          <p className="body-sm" style={{ color: 'var(--token-desc)', marginTop: '4px' }}>
            {subscribers.length} subscriber{subscribers.length !== 1 ? 's' : ''}
          </p>
        </div>
        {subscribers.length > 0 && (
          <button className="btn btn-outline" onClick={exportCSV}>↓ Export CSV</button>
        )}
      </div>

      {loading ? (
        <div style={{ padding: '48px', textAlign: 'center', color: 'var(--token-desc)' }}>Loading...</div>
      ) : subscribers.length === 0 ? (
        <div style={{ padding: '48px', textAlign: 'center', color: 'var(--token-desc)', background: '#fff', borderRadius: '8px' }}>
          No subscribers yet. The subscribe form in the footer will populate this list.
        </div>
      ) : (
        <table className="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Email</th>
              <th>Source</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {subscribers.map((sub, i) => (
              <tr key={sub.id}>
                <td style={{ color: 'var(--token-desc)', width: '40px' }}>{i + 1}</td>
                <td>
                  <a href={`mailto:${sub.email}`} style={{ color: 'var(--primary-500)', textDecoration: 'none' }}>
                    {sub.email}
                  </a>
                </td>
                <td>{sub.source || '—'}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{formatDate(sub)}</td>
                <td>
                  <button
                    style={{ padding: '4px 12px', height: 'auto', fontSize: '13px', background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                    onClick={() => handleDelete(sub)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}